import './Loader.css';
import React, { useContext, useState, useEffect, useMemo } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { get, getPageThemeColors, canUseDOM } from '../../../utils';
const Loader = props => {
  const [isVdsite, setIsVdsite] = useState(true);
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const pageThemeColors = useMemo(() => getPageThemeColors(isVdsite), [isVdsite]);
  const colorFallback = primaryPageThemeColor ? primaryPageThemeColor : pageThemeColors.primary;
  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  const variables = {
    "--loader-color": props.color ? props.color : colorFallback
  };
  return /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: `loader-component ${commonStyles}`
  }));
};
const commonStyles = "c17ozkk4";
export default Loader;